module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9569.3b94debc.jpg";